import { render, staticRenderFns } from "./FaceToFaceTable.vue?vue&type=template&id=638bdd99&scoped=true&"
import script from "./FaceToFaceTable.vue?vue&type=script&lang=js&"
export * from "./FaceToFaceTable.vue?vue&type=script&lang=js&"
import style0 from "./FaceToFaceTable.vue?vue&type=style&index=0&id=638bdd99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638bdd99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
